





export default {
  name: 'SidebarGroupLabel',
};
